import { useState } from "react";
import classNames from "classnames";
import checkMarkIcon from "/assets/check-mark.svg";
import arrowDownIcon from "/assets/arrow-down.svg";
import { sortedOptionEntries } from "/utils/helpers";

export default function InlineSelect({
  label,
  options,
  locale,
  onChange,
  selectedOptions = [],
}) {
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);

  const toggleOption = (key) => {
    if (selectedOptions.includes(key)) {
      removeOption(key);
    } else {
      addOption(key);
    }
  };

  const addOption = (key) => {
    if (typeof onChange !== 'function') return;

    onChange([...selectedOptions, key]);
  };

  const removeOption = (key) => {
    if (typeof onChange !== 'function') return;

    onChange(selectedOptions.filter(o => o != key));
  };

  return (
    <div className="inline-select">
      <div
        className="inline-select__label"
        onClick={() => setIsOptionsVisible(value => !value)}
      >
        <span>{label}</span>

        <img
          src={arrowDownIcon}
          className={classNames("inline-select__arrow-icon", { "inline-select__arrow-icon--open": isOptionsVisible })}
        />
      </div>

      <div className={classNames("inline-select__options", { "inline-select__options--collapsed": !isOptionsVisible })}>
        {sortedOptionEntries(options, locale).map(([key, value]) => {
          const isSelected = selectedOptions.includes(key);

          return (
            <div
              key={key}
              onClick={() => toggleOption(key)}
              className={classNames("inline-select__option", { "inline-select__option--selected": isSelected })}
            >
              <div className={classNames("inpt-checkbox", { "inpt-checkbox--checked": isSelected })}>
                <img src={checkMarkIcon} />
              </div>

              {value}
            </div>
          );
        })}
      </div>
    </div>
  );
}
